/**
 * Découper une image en JPEG à la toile du navigateur : la photo de profil (`avatarImage.web.ts`) et le
 * recadrage d'une photo avant sa lecture (`cropImageFile.web.ts`). Charger l'image, en dessiner une zone
 * à une taille donnée, l'encoder : le JPEG est servi par une adresse `blob:` que `dispose` libère.
 */

export function loadImage(uri: string, options: { crossOrigin?: boolean } = {}): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
        const image = new Image()
        if (options.crossOrigin === true) image.crossOrigin = "anonymous"
        image.onload = () => resolve(image)
        image.onerror = () => reject(new Error("image illisible"))
        image.src = uri
    })
}

export type CanvasRect = { x: number; y: number; width: number; height: number }

/** La zone `from` de l'image, dessinée à `to` (largeur, hauteur), en JPEG à `quality`. Lève si rien n'est encodé. */
export async function drawJpeg(
    source: HTMLImageElement,
    from: CanvasRect,
    to: { width: number; height: number },
    quality: number
): Promise<{ uri: string; dispose: () => void }> {
    const canvas = document.createElement("canvas")
    canvas.width = to.width
    canvas.height = to.height
    const context = canvas.getContext("2d")
    if (context == null) throw new Error("canevas indisponible")
    context.drawImage(source, from.x, from.y, from.width, from.height, 0, 0, to.width, to.height)
    const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, "image/jpeg", quality))
    if (blob == null) throw new Error("photo non encodée")
    const uri = URL.createObjectURL(blob)
    return { uri, dispose: () => URL.revokeObjectURL(uri) }
}
